<template>
    <div style="margin-left: 28px">
        <div class="mainDiv">
            <div class="inputDiv" style="">
                <div class="rupeeDiv">
                    <img src="../../../../assets/rupee.svg" alt="" />
                </div>
                <div class="inputBox">
                    <input class="input" @input="validateValues" v-model="minValue" placeholder="Min. Value" />
                </div>
            </div>

            <div class="inputDiv">
                <div class="rupeeDiv">
                    <img src="../../../../assets/rupee.svg" alt="" />
                </div>
                <div class="inputBox">
                    <input
                        class="input"
                        @input="validateValues"
                        v-model="maxValue"
                        type="text"
                        placeholder="Max. Value"
                    />
                </div>
            </div>
        </div>
        <div v-if="showErrorMessage" class="error-message">Note: Min. value cannot be more than max. value</div>
    </div>
</template>

<script>
export default {
    name: "inputButton",
    data() {
        return {
            minValue: "",
            maxValue: "",
            minPlaceholderText: "Minimum value",
            maxPlaceholderText: "Maximum value",
            showErrorMessage: false,
        };
    },
    methods: {
        validateValues() {
            if (this.minValue !== "" && this.maxValue !== "" && parseInt(this.minValue) > parseInt(this.maxValue)) {
                this.showErrorMessage = true;
            } else {
                this.showErrorMessage = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.currency-prefix {
    position: absolute;
    padding: 0.5rem;
    pointer-events: none;
}
.inputDiv {
    background: #ffffff;
    display: flex;
    border: 1px solid #efefef;
    border-radius: 4px;
    width: 160px;
    height: 43px;
}
.error-message {
    color: red;
    margin-top: 0.5rem;
}
.rupeeDiv {
    width: 16%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.inputBox {
    width: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.input {
    width: 80%;
    padding: 3px;
}
.mainDiv {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0px;
    gap: 16px;
    width: 336px;
    height: 43px;
}
</style>

